import React from "react";
import { motion } from "framer-motion";
import FeatureItem from "./FeatureItem";

const Curriculum = () => {
    const features = [
        "Structured Learning: Clear progression through key language skills.",
        "Interactive Lessons: Engaging activities to enhance understanding.",
        "Personalized Feedback: Tailored guidance for individual growth.",
    ];

    return (
        <section className="flex justify-center items-center px-80 py-20 bg-black min-h-[760px] max-md:px-10 max-md:py-16 max-sm:px-5 max-sm:py-10">
            <motion.div className="flex gap-12 items-start max-w-screen-xl max-md:flex-col max-md:items-center"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
                viewport={{ once: true }}
            >
                <img
                    src={`${process.env.REACT_APP_BASE_URL}/images/blog_1.png`}
                    className="object-cover rounded h-[550px] w-[550px] max-md:w-full max-md:h-auto max-md:max-w-[600px]"
                    alt="Students learning English"
                />
                <article className="pt-10 max-w-[630px] max-md:pt-10 max-md:max-w-full">
                    <h2 className="mb-5 text-4xl font-bold text-white leading-[50.4px] max-md:text-4xl max-md:leading-10 max-sm:text-3xl max-sm:leading-9">
                        <span>Our Proven Curriculum for </span>
                        <span className="italic">Lasting English Proficiency</span>
                    </h2>
                    <p className="mb-14 text-lg leading-7 text-white max-md:text-base max-md:leading-6 max-sm:text-sm max-sm:leading-5 text-justify">
                        At iExcel International English, our curriculum is meticulously
                        crafted to ensure students develop a strong foundation in English.
                        We focus on reading, writing, speaking, and comprehension, providing
                        a balanced approach to language acquisition. Our methods are
                        designed to be engaging and effective, fostering a love for
                        learning.
                    </p>
                    <ul className="flex flex-col gap-1">
                        {features.map((feature, index) => (
                            <FeatureItem key={index} text={feature} />
                        ))}
                    </ul>
                </article>
            </motion.div>
        </section>
    );
};
export default Curriculum;